<div class="counts" *ngIf="serviceCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Service Scheduling
        <span>{{ serviceCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'serviceCounts',
          'pendingServiceToSchedule'
        ]"
      >
        <p class="count">Pending Service to Schedule</p>
        <span>{{ serviceCounts.pendingServiceToSchedule }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'serviceCounts', 'serviceScheduled']"
      >
        <p class="count">Service Scheduled</p>
        <span>{{ serviceCounts.serviceScheduled }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'serviceCounts',
          'assuranceProjectsToSchedule'
        ]"
      >
        <p class="count">Assurance to Schedule</p>
        <span>{{ serviceCounts.assuranceProjectsToSchedule }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
